// Import extend function.
import Component from '../../../js/core/component.js';

class FormFormula extends Component {

	_defaultSettings () {
		return {
			debug: false
		};
	}

	_init () {
		if (this.inited) {
			this._log('Formula is already inited');
			return;
		}

		this.inited = true;
	}

	setupFormula (item) {
		item.style.display = 'block';
		let display = item.querySelector('dd');
		let operation = item.dataset.formula.match(/(\+|\-|\*|\/)/);
		operation = operation[0];
		let decimals = item.dataset.decimals;
		let names = item.dataset.formula.match(/\w+/g);

		let inputs = [];
		names.forEach(name => {
			inputs.push(document.querySelector(`[name=${name}]`));
		});

		inputs.forEach(input => {
			input.addEventListener('input', () => {
				let sum = this._recalculate(operation, inputs);

				if (sum != '' && decimals != null) {
					sum = sum.toFixed(parseInt(decimals)); // Set to wanted decimals
				}
				else if (decimals == null) {
					sum = sum.toFixed(0); // If decimals not specified set to 0 decimals
				}

				sum = sum.replace(/\./g, ','); // Replace . with , for presentation

				let sumHolder = display.querySelector('span');

				if (sumHolder) {
					sumHolder.innerHTML = `${sum} `;
				}
				else {
					let sumEl = document.createElement('span');
					sumEl.append(`${sum} `);
					display.prepend(sumEl);
				}
			});
		});
	}

	_recalculate (operation, inputs) {
		let values = [];
		inputs.forEach(input => {
			if (input.value != '') {
				let val = input.value.replace(/,/g, '.');
				values.push(parseFloat(val));
			}
		});

		if (values.length == 0) {
			return '';
		}
		else if (values.length > 1) {
			switch (operation) {
				case '+':
					return values.reduce((sum, val) => sum + val);
				case '-':
					return values.reduce((sum, val) => sum - val);
				case '*':
					return values.reduce((sum, val) => sum * val);
				case '/':
					return values.reduce((sum, val) => sum / val);
				default:
					break;
			}
		}
		else {
			return values[0];
		}
	}
}

export default FormFormula;



// WEBPACK FOOTER //
// ./components/form-elements/form/c-form-formula.js